<div data-cy="project-config-imports__page" class="mt-30">
    <div class="col-xs-6">
        <div class="gd-horizontal mb-15 align-center">
            <span>
                <i class="uil uil-import fs-24 mr-8"></i>
                <span class="fs-24 generic-color">
                    {{ 'imports.title' | transloco }}
                </span>
            </span>

            <button data-cy="project-config-imports__open-selectgeo-json-modal-btn" mat-flat-button (click)="openSelectgeoJsonModal()">
                <i class="uil uil-plus-circle"></i>
                {{ 'imports.new_import' | transloco }}
            </button>
        </div>
        <div class="search-box-container">
            <i class="uil uil-search uil-icon"></i>
            <input data-cy="project-config-imports__search-box-input" class="search-box" placeholder="{{'text.search_in_subprojects' | transloco}}" [value]="searchTerm"
                (keyup)="onSearchInput($event)">
        </div>

        <div class="full-width table-wraper mt-5">
            <div class="loading-overlay" *ngIf="loading()">
                <mat-spinner diameter="40"></mat-spinner>
            </div>
            <table data-cy="project-config-imports__table" mat-table [dataSource]="tableData" class="imports-table" matSort *ngIf="!loading()" #sortTable="matSort">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                    </th>

                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox data-cy="project-config-imports__checkbox" [checked]="selectedFileId === element.id" (change)="onSelectRow(element, $event.checked)"></mat-checkbox>
                    </td>
                </ng-container>

                <!-- File Name Column -->
                <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
                        <span class="font-normal">{{ 'imports.file_name' | transloco }}</span>
                    </th>
                    <td mat-cell *matCellDef="let element" class="file-name-cell"  [ngClass]="{'generic-color' : selectedFileId===element.id, 'font-bold': selectedFileId===element.id, 'd-cursor-hand': element.status.toLowerCase() === 'partially-failed'}">
                        <i class="uil uil-file fs-18 mr-6"></i>
                        <span data-cy="project-config-imports__on-row-click" class="file-name clickable-status" [matTooltip]="element.name" (click)="onRowClick(element); $event.stopPropagation()">{{ splitFileName(element.name).fileName | trunc:70 }}</span>
                    </td>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="importDate">
                        <span class="font-normal">{{ 'imports.date' | transloco }}</span>
                    </th>

                    <td mat-cell *matCellDef="let element">
                        <span>{{ element.importDate || element.created_at || element.createdAt | formatdate: 'dd-MM-yyyy HH:mm' : globals.timezone }}</span>
                    </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status">
                        <span class="font-normal">{{ 'imports.status' | transloco }}</span>
                    </th>

                    <td mat-cell *matCellDef="let element">
                        <div class="status" [ngClass]="element.status.toLowerCase()" [class.d-cursor-hand]="element.status.toLowerCase() === 'partially-failed'" (click)="onRowClick(element); $event.stopPropagation()">
                            <img *ngIf="element?.status?.toLowerCase() === 'success'" [style.width.px]="17" [style.height.px]="17" src="assets/icons/success.svg" alt="success">
                            <img *ngIf="element?.status?.toLowerCase() === 'failed'" [style.width.px]="20" [style.height.px]="20" src="assets/icons/failed.svg" alt="success">
                            <i *ngIf="element.status?.toLowerCase() === 'warning'" class="uil uil-exclamation-triangle"></i>
                            <i *ngIf="element.status?.toLowerCase() === 'processing'" class="uil uil-sync"></i>
                            <i *ngIf="element.status?.toLowerCase() === 'partially-failed'" class="uil uil-exclamation-triangle text-warning icon-color"></i>
                            {{ getStatusTranslationKey(element.status) | transloco }}
                        </div>
                    </td>
                </ng-container>

                <!-- Details Column -->
                <ng-container matColumnDef="details">
                    <th mat-header-cell *matHeaderCellDef></th>

                    <td mat-cell *matCellDef="let element">
                        <div class="details-cell d-cursor-hand" *ngIf="selectedFileId === element.id">
                            <!-- <i class="uil uil-trash mr-6"></i> -->
                            <span data-cy="project-config-imports__on-select-file-detail" class="detail-grp" (click)="onSelectFileDetail(element)">
                                <span class="details-link fs-8">{{ 'imports.details' | transloco }}</span>
                                <i class="uil uil-angle-right-b fs-25"></i>
                            </span>
                        </div>
                    </td>
                </ng-container>

                <!-- Empty State Column -->
                <ng-container matColumnDef="empty">
                    <td mat-footer-cell *matFooterCellDef colspan="5" class="text-center py-4">
                        <div class="empty-state">
                            <i class="uil uil-file fs-55 mb-2 generic-color"></i>
                            <p class="mt-2">{{ 'imports.no_imports' | transloco }}</p>
                            <p class="mt-3 empty-p">{{ 'imports.no_imports_description' | transloco }}</p>
                            <button data-cy="project-config-imports__open-selectgeo-json-modal-btn-2" mat-flat-button class="mt-15" (click)="openSelectgeoJsonModal()">
                                <i class="uil uil-plus-circle mr-2"></i>
                                {{ 'imports.no_imports_button' | transloco }}
                            </button>
                        </div>
                    </td>
                </ng-container>

                <!-- Table Header & Rows -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.selected-row]="selectedFileId === row.id"
                ></tr>
                <!-- Conditional Footer Row -->
                <ng-container *ngIf="tableData.data.length === 0">
                    <tr mat-footer-row *matFooterRowDef="['empty']"></tr>
                </ng-container>
            </table>
        </div>
    </div>

    <div [class.col-xs-3]="selectedFile" [class.d-none]="!selectedFile">
        <span class="title">
            <i class="uil uil-file fs-20 mr-8"></i>
            <span class="fs-20 generic-color">{{ 'imports.import_details' | transloco }}</span>
        </span>

        <div class="detail-card mt-25">
            <h3 class="generic-color mb-8" [matTooltip]="selectedFile?.name">{{ selectedFile?.name | trunc:40 }}</h3>
            <p class="mb-4 clr-black">{{ 'imports.import_on' | transloco }} {{ selectedFile?.updated_at | date:'medium' }}</p>
            <p class="mb-22 clr-black">{{ selectedFile?.type=='geojson' ? 'Json file':'imports.excel_file' | transloco }}</p>

            <h3 class="mb-6">{{ 'imports.status' | transloco }}</h3>
            <span class="status" [ngClass]="selectedFile?.status?.toLowerCase()">
                <img *ngIf="selectedFile?.status?.toLowerCase() === 'success'" [style.width.px]="17" [style.height.px]="17" src="assets/icons/success.svg" alt="success">
                <img *ngIf="selectedFile?.status?.toLowerCase() === 'failed'" [style.width.px]="20" [style.height.px]="20" src="assets/icons/failed.svg" alt="success">
                <i *ngIf="selectedFile?.status?.toLowerCase() === 'warning'" class="uil uil-exclamation-triangle"></i>
                <i *ngIf="selectedFile?.status?.toLowerCase() === 'processing'" class="uil uil-sync"></i>
                {{ getStatusTranslationKey(selectedFile?.status) | transloco }}
            </span>
        </div>
    </div>

    <div [class.col-xs-3]="selectedFile" [class.col-xs-6]="!selectedFile">
        <div class="gd-horizontal mb-15 align-center">
            <span class="title">
                <i class="uil uil-table fs-20 mr-8"></i>
                <span class="fs-20 generic-color">{{ 'imports.import_templates' | transloco }}</span>
            </span>
            <span>
                <i class="uil uil-angle-left-b generic-color fs-20"></i>
            </span>
        </div>

        <mat-divider class="mt-25"></mat-divider>

        <div class="mt-15 template-card">
            <div class="template-info">
                <span class="template-title">
                    <i class="uil uil-file"></i>
                    <h3>{{ 'imports.excel_template_title' | transloco }}</h3>
                    <span>{{ 'imports.excel_file' | transloco }}</span>
                </span>
                <span class="template-desc">{{ 'imports.excel_template_description' | transloco }}</span>
            </div>
            <button data-cy="project-config-imports__dwnld-btn" class="dwnld-btn" (click)="downloadTemplate('excel')">{{ 'imports.download' | transloco }}</button>
        </div>

        <mat-divider class="mt-15"></mat-divider>

        <div class="mt-15 template-card">
            <div class="template-info">
                <span class="template-title">
                    <i class="uil uil-file"></i>
                    <h3>{{ 'imports.geojson_template_title' | transloco }}</h3>
                    <span>{{ 'imports.json_file' | transloco }}</span>
                </span>
                <span class="template-desc">{{ 'imports.geojson_template_description' | transloco }}</span>
            </div>
            <button data-cy="project-config-imports__dwnld-btn-2" class="dwnld-btn" (click)="downloadTemplate('geojson')">{{ 'imports.download' | transloco }}</button>
        </div>

        <mat-divider class="mt-15"></mat-divider>
    </div>
</div>